export const SET_THEME_DARK = "SET_THEME_DARK";

export const SET_THEME_LIGHT = "SET_THEME_LIGHT";

export const TOGGLE = "TOGGLE";

export const GET_ERRORS = "GET_ERRORS";

export const SET_CURRENT_USER = "SET_CURRENT_USER";

export const AUTH_LOADING = "AUTH_LOADING";

export const CLEAR_ERRORS = "CLEAR_ERRORS";

export const ADD_POST = "ADD_POST";

export const POST_LOADING = "POST_LOADING";

export const GET_POSTS = "GET_POSTS";

export const GET_POST = "GET_POST";

export const GET_POSTS_SCROLL = "GET_POSTS_SCROLL";

export const DELETE_POST = "DELETE_POST";

export const ADD_CAT = "ADD_CAT";

export const ADD_SUB_CAT = "ADD_SUB_CAT";

export const CAT_LOADING = "CAT_LOADING";

export const GET_CATS = "GET_CATS";

export const GET_CAT = "GET_CAT";

export const GET_CATS_SCROLL = "GET_CATS_SCROLL";

export const WESBITE_LOADING = "WESBITE_LOADING";

export const GET_WESBITE = "GET_WESBITE";

export const GET_CART = "GET_CART";

export const GET_CART_PRODUCTS = "GET_CART_PRODUCTS";

export const CART_LOADING = "CART_LOADING";

export const GET_WISHLIST = "GET_WISHLIST";

export const GET_WISHLIST_PRODUCTS = "GET_WISHLIST_PRODUCTS";

export const WISHLIST_LOADING = "WISHLIST_LOADING";

export const DRAWER_TOGGLE = "DRAWER_TOGGLE";

